/* eslint-disable no-unused-vars */
// linter gives a false-positive for typescript-enums, needs to investigate
export enum ChatSubscriptionTypeEnum {
  NODE = 'node',
  ALIAS = 'alias',
}
